import React from 'react';
import { Switch, SwitchThumb } from '@radix-ui/react-switch';
import { cn } from '~/helpers/utils';
import { Controller, useFormContext } from 'react-hook-form';

type ToggleBooleanFieldProps = {
  name: string;
  label: string;
};

const ToggleBooleanField: React.FC<ToggleBooleanFieldProps> = ({
 name,
 label,
}) => {
  const { control } = useFormContext();
  
  const inputId = `field-${name}`;

  return (
    <div className="form-control">
      <label
        htmlFor={inputId}
        className="form-label"
      >
        {label}
      </label>
      
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <>
            <Switch
              id={inputId}
              checked={!!field.value}
              onCheckedChange={(checked) => field.onChange(checked)}
              className={cn(
                'relative w-12 h-6 rounded-full transition-colors cursor-pointer border',
                'bg-stone-100 border-stone-200  data-[state=checked]:bg-blue-600 data-[state=checked]:border-blue-600',
                'focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2',
              )}
            >
              <SwitchThumb
                className={cn(
                  'block w-4 h-4 bg-white rounded-full shadow-md transition-transform duration-200',
                  'translate-x-1 data-[state=checked]:translate-x-6',
                )}
              />
            </Switch>
            {fieldState.error && (
              <span className="text-sm text-tomato-600">{fieldState.error.message}</span>
            )}
          </>
        )}
      />
    </div>
  );
};

export default ToggleBooleanField;